'use client';

import React, { createContext, useContext } from 'react';

export const LanguageContext = createContext<string | null>(null);

export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  if (context === null) {
    throw new Error('[useLanguageContext] is not wrapped inside a provider');
  }
  return context;
};

export function LanguageContextProvider({
  value,
  children,
}: {
  value: string;
  children: React.ReactNode;
}) {
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
